<template>
  <div style="height: 100vh; overflow:auto" class="nearModelBg">
    <!-- 导航栏 -->
    <Header :title="$t('T_NEAR_MODELS')" link="projectorInfo" @back="backAction" ></Header>
    <!-- 列表展示 -->
    <div class="list-box appContent modelList ">
      <modelItem v-for='(item, index) in nearModelListSort' :key='index' :modelData="item" @onModelChange="onModelChange"></modelItem>
    </div>
  </div>
</template>

<script>
import modelItem from '@/components/ModelItem'
import Header from '@/components/header'

export default {
  name: 'nearModel',
  data () {
    return {
      radio: 0,
      nearModelListSort: []
    }
  },
  props: ['nearModelList'],
  methods: {
    backAction () {
      this.$emit('close')
    },

    onModelChange (value) {
      this.$emit('onModelChange', value)
      this.backAction()
    }
  },
  mounted () {
    this.nearModelListSort = this.nearModelList
    this.nearModelListSort.sort((obj1, obj2) => {
      return obj1.name.localeCompare(obj2.name)
    })
  },
  components: {
    modelItem,
    Header
  }
}
</script>

<style scoped>
  .list-box{
    padding:0px 18px 10px 18px
  }
  .van-radio{
    margin-bottom:10px;
    font-size: 20px
  }

</style>
